/**
 * Messaggi e info sul file caricato (estratti da FantAPP via mixin sul prototype).
 * Tutte le funzioni usano `this` (l'istanza FantAPP) esattamente come prima.
 */
import { formatBytes } from '../utils/formatBytes.js';

/**
 * Mostra informazioni del file selezionato
 */
export function showFileInfo(file) {
  const fileInfo = document.getElementById('file-info');
  const fileName = document.getElementById('file-name');
  const fileSize = document.getElementById('file-size');

  if (fileInfo && fileName && fileSize) {
    fileName.textContent = file.name;
    fileSize.textContent = this.formatFileSize(file.size);
    fileInfo.style.display = 'block';

    // Nasconde il quick reload card se visibile
    const quickReloadCard = document.getElementById('quick-reload-card');
    if (quickReloadCard) {
      quickReloadCard.style.display = 'none';
    }
  }
}

/**
 * Formatta dimensione file
 */
export function formatFileSize(bytes) {
  return formatBytes(bytes, {
    zeroLabel: '0 Bytes',
    unitNames: ['Bytes', 'KB', 'MB', 'GB'],
  });
}

/**
 * Mostra messaggio successo file
 */
export function showFileSuccess(count, withStats) {
  const container = document.querySelector("#auction-setup-screen .setup-container");
  if (!container) return;

  // Rimuovi messaggi precedenti
  container.querySelectorAll(".file-message").forEach((m) => m.remove());

  const message = document.createElement("div");
  message.className = "file-message success";
  message.innerHTML = `
    <strong>File caricato</strong><br />
    ${count} giocatori disponibili${withStats ? ` (${withStats} con statistiche)` : ""}
  `;

  container.appendChild(message);

  // Auto-remove dopo 5 secondi
  setTimeout(() => {
    if (message.parentNode) {
      message.remove();
    }
  }, 5000);
}

/**
 * Mostra messaggio errore file
 */
export function showFileError(error) {
  const container = document.querySelector("#auction-setup-screen .setup-container");
  if (!container) return;

  // Rimuovi messaggi precedenti
  container.querySelectorAll(".file-message").forEach((m) => m.remove());

  const message = document.createElement("div");
  message.className = "file-message error";
  message.innerHTML = `
    <strong>Errore caricamento</strong><br />
    ${error}
  `;

  container.appendChild(message);

  // Auto-remove dopo 8 secondi per gli errori
  setTimeout(() => {
    if (message.parentNode) {
      message.remove();
    }
  }, 8000);
}

/**
 * Mostra messaggio errore generico
 */
export function showErrorMessage(message) {
  // Toast o alert per errori critici
  if (window.CustomDialogs) {
    window.CustomDialogs.alert("Errore", message);
  } else {
    alert(message);
  }
}
